import "../styles/branding.css";
import { useInView } from "react-intersection-observer";

function Branding(props) {
  const [ref, inView] = useInView({ threshold: 0.2 });
  return (
    <section ref={ref} className="u-clearfix u-section-25" id="Branding">
      <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
        <div className="u-layout">
          <div className="u-layout-row">
            <div
              className="u-align-left u-container-align-center u-container-style u-image u-layout-cell u-left-cell u-size-30 u-size-xs-60 u-image-1"
              src=""
              data-image-width="961"
              data-image-height="905"
            >
              <div
                className="u-container-layout u-valign-middle u-container-layout-1"
                src=""
              ></div>
            </div>
            <div className="u-align-left u-container-style u-layout-cell u-palette-3-base u-right-cell u-size-30 u-size-xs-60 u-layout-cell-2">
              <div className="u-container-layout u-container-layout-2">
                <h3 className="u-align-right u-text u-text-default u-text-white u-text-1">
                  {props.t("seccion25_1")}
                </h3>
                <p className="u-align-right u-text u-text-white u-text-3">
                  {props.t("seccion25_2")}
                </p>
                <span
                  onClick={() => props.openModal(props.t("button_6"))}
                  className="u-align-left u-border-2 u-border-grey-75 u-btn u-btn-round u-button-style u-hover-palette-1-dark-1 u-palette-2-base u-radius-50 u-btn-1"
                >
                  {" "}
                  {props.t("button_6")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Branding;
